import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router'
import Footer from './Footer.jsx'
import Header from './Header.jsx'

/** Standard page: header with divider, content, footer. */
export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  )
}

/** Keeps <html lang> in sync and scrolls to top on navigation. */
export function PageEffects() {
  const { i18n } = useTranslation()
  const { pathname } = useLocation()
  useEffect(() => {
    document.documentElement.lang = i18n.resolvedLanguage ?? 'en'
  }, [i18n.resolvedLanguage])
  useEffect(() => window.scrollTo(0, 0), [pathname])
  return null
}
